<div mat-dialog-content fxLayout="column">
  <p>{{message}}</p>
  <div>
    <div class="loading-icon-bubbles">Loading...</div>
  </div>
</div>
